import React from 'react';
import cx from 'classnames';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

import styles from './CopiedModal.module.less';

type CopiedModalProps = {
  previewComponent: () => JSX.Element;
  transferToPaper: () => void;
  hideModalCopied: () => void;
  modalSettings: {
    promoCode: string;
    discountAmount: number;
    pricePerItem: number;
  };
};

const CopiedModal = ({
  previewComponent,
  transferToPaper,
  hideModalCopied,
  modalSettings,
}: CopiedModalProps): JSX.Element => {
  const { promoCode, discountAmount, pricePerItem } = modalSettings;
  const { width, height } = previewComponent().props.page;
  const isLandscape = width > height;
  return (
    <div className={styles.copiedModalWrapper}>
      <div className={styles.copiedModalContent}>
        <div className={styles.textWrapper}>
          <h2 className={styles.titleText}>Copied!</h2>
          <h2 className={styles.titleText}>
            {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
            Send paper save the dates now <span role="img">💌</span>
          </h2>
          <span className={styles.subTitleText}>
            Go hybrid! We&apos;ve transferred all your details to traditional paper save the dates,
            starting at just ${pricePerItem} each.
          </span>
          <span className={styles.redTip}>
            Get {discountAmount}% off at checkout with code {promoCode}.
          </span>
        </div>
        <div className={styles.canvasWrapper}>
          {previewComponent()}
          <div
            className={cx(styles.upsellHand, {
              [styles.upsellHandPortrait]: !isLandscape,
              [styles.upsellHandLandscape]: isLandscape,
            })}
          />
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        <ButtonV2 onClick={() => hideModalCopied()} variant="secondary">
          Maybe Later
        </ButtonV2>
        <ButtonV2 onClick={() => transferToPaper()}>View Paper</ButtonV2>
      </div>
    </div>
  );
};

export default CopiedModal;
